<template>
  <button
    class="vi-button"
    :type="type"
    :class="{sm: this.size === 'sm'}"
    :disabled="disabled"
    @click="onClick">
    {{label}}
  </button>
</template>

<script>
  export default {
    props: {
      label: {
        type: String,
        required: true
      },
      size: {
        type: String,
      },
      type: {
        type: String,
        default: 'submit'
      },
      disabled: {
        type: Boolean
      }
    },
    methods: {
      onClick(e) {
        this.$emit('click', e)
      }
    }
  }
</script>

<style lang="scss">
  @import "../../styles/vars";

  .vi-button {
    padding: 6px 30px;
    /*border-radius: 4px;*/
    /*box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.1);*/
    border: none;
    font-size: 14px;
    color: #ffffff;
    background: $clBrand;
    cursor: pointer;
    border-radius: 20px;
    outline: none;

    &:disabled {
      background: darken($clBrand, 10);
      content: normal;
    }

    &:active {
      transform: scale(1.1);
    }

    &.sm {
      padding: 7px 10px;
      font-size: 1rem;
    }
  }
</style>
